import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    techniques: [],
    totalPages: null,
    totalTechniques: null,
    selectedTechnique: null,
    isLoading: false,
    error: null
};

const techniquesSlice = createSlice({
    name: "techniques",
    initialState,
    reducers: {
        setTechniques: (state, action) => {
            state.techniques = action.payload;
        },
        setSelectedTechnique: (state, action) => {
            state.selectedTechnique = action.payload;
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        setTotalTechniques: (state, action) => {
            state.totalTechniques = action.payload;
        }
    }
});

export const {
    setTechniques,
    setSelectedTechnique,
    setLoading,
    setError,
    setTotalPages,
    setTotalTechniques
} = techniquesSlice.actions;

export const techniquesReducers = techniquesSlice.reducer;